import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UniquUserLookupComponent } from './uniqu-user-lookup/uniqu-user-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [UniquUserLookupComponent],
  exports: [UniquUserLookupComponent],
})
export class UniqueUserLookupModule { }
